import { useContext } from 'react';
import { PickerContext } from '.';
export const usePickerContext = () => {
    const context = useContext(PickerContext);
    if (!context) {
        throw new Error('usePickerContext must be used as a child to <PickerProvider>');
    }
    return context;
};
